export enum vendorEnum {
    outlook = 1,
    gmail = 2
}